module.exports = __webpack_public_path__ + "img/volume-off-solid.f0e66712.svg";